'use strict';

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _noHtml = require('./validation/noHtml');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Validation');
var userReviewService = abp.services.api.userReview;

module.exports = exports.default = function () {
    (0, _jquery2.default)(document).ready(function () {
        recalculateReviews();
    });

    (0, _jquery2.default)(document).on('click', '#nextCustomerXReviews', function () {
        var skip = (0, _jquery2.default)('.userReview').length;

        loadReviews(skip);

        return false;
    });

    (0, _jquery2.default)(document).on('click', '#addNewUserReview', function () {
        var reviewText = (0, _jquery2.default)('#newUserReviewText').val();

        if (reviewText === '') {
            return;
        }

        if ((0, _noHtml.containsHtmlTag)(reviewText)) {
            _notify2.default.error(Resx.Validation.NoHtml_ValidationError);
            return;
        }

        var productId = (0, _jquery2.default)("#ProductId").val();

        userReviewService.addUserReview({
            ProductId: productId,
            Text: reviewText
        }).done(function (result) {
            (0, _jquery2.default)('#newUserReviewText').val("");
            (0, _jquery2.default)('.p-u-reviews__add').css('display', 'none');

            var take = (0, _jquery2.default)('.userReview').length > 1 ? (0, _jquery2.default)('.userReview').length : (0, _jquery2.default)('.userReview').length + 1;
            clearReviews();
            loadReviews(0);

            _notify2.default.success(Resx.App.UserReviewThanksForAdding);
        }).fail(function (result) {
            _notify2.default.error(result.responseJSON.error.message);
        });
        return false;
    });

    function clearReviews() {
        (0, _jquery2.default)('.userReview').remove();
        (0, _jquery2.default)('#UserReviewsCount').val(parseInt((0, _jquery2.default)('#UserReviewsCount').val()) + 1);
    }

    function loadReviews(skip) {
        var productId = (0, _jquery2.default)("#ProductId").val();

        userReviewService.getReviewsForProduct(productId, skip).done(function (result) {
            for (var i = 0; i < result.length; i++) {
                addReviewToList(result[i]);
            }

            recalculateReviews();
        }).fail(function (result) {
            _notify2.default.error(result.responseJSON.error.message);
        });
    }

    function recalculateReviews() {
        var reviewCount = parseInt((0, _jquery2.default)('#UserReviewsCount').val());
        var reviewsDisplayed = (0, _jquery2.default)('.userReview').length;

        if (reviewsDisplayed < reviewCount) {
            (0, _jquery2.default)('#nextCustomerXReviews').show();
            if (reviewCount - reviewsDisplayed <= 4) {
                (0, _jquery2.default)('#nextCustomerXReviews').html(Resx.App.NextXReviews.replace('{x}', reviewCount - reviewsDisplayed));
            } else {
                (0, _jquery2.default)('#nextCustomerXReviews').html(Resx.App.NextXReviews5.replace('{x}', reviewCount - reviewsDisplayed));
            }
        } else {
            (0, _jquery2.default)('#nextCustomerXReviews').hide();
        }
    }

    function addReviewToList(review) {
        (0, _jquery2.default)("#noUserReviewsCreated").hide();

        var creationTime = new Date(review.creationTime).toLocaleDateString();
        var reviewElement = (0, _jquery2.default)("<div class=\"userReview p-u-review\">" + "<div class=\"p-u-review__left\">" + "<select class=\"barRating\" data-select2=\"false\">" + "<option value=\"\">0</option>" + "<option value=\"1\">1</option>" + "<option value=\"2\">2</option>" + "<option value=\"3\">3</option>" + "<option value=\"4\">4</option>" + "<option value=\"5\">5</option>" + "</select>" + "<div class='p-u__author'></div>" + "<time></time>" + "</div>" + "<div class=\"p-u-review__right\">" + "<div></div>" + "</div>" + "</div>");

        reviewElement.find('.p-u__author').text(review.creatorUser === null ? "-" : review.creatorUser.name);
        reviewElement.find('time').text(creationTime);
        reviewElement.find('.p-u-review__right > div').text(review.text);
        (0, _jquery2.default)("#customerReviews").append(reviewElement);

        (0, _jquery2.default)(".userReview .barRating").last().barrating({
            theme: '', // my own theme
            initialRating: review.rating,
            deselectable: false,
            readonly: true
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/userReviewProduct.js
// module id = 1096
// module chunks = 1